import type { FormDialogModel } from './hooks/useFormDialog';
import type { TabItem } from '@/components/custom/erp';
import EInvoiceTab from './EInvoiceTab';
import DetailTab from './DetailTab';
import OtherTab from './OtherTab';

export const FormTabs = (dialog: FormDialogModel): TabItem[] => [
  {
    id: 'details',
    label: 'Chi tiết',
    component: (
      <DetailTab
        rows={dialog.detail.rows}
        selectedRowUuid={dialog.detail.selectedRowUuid}
        selectedCell={dialog.detail.selectedCell}
        handleRowClick={dialog.detail.handleRowClick}
        handleCellClick={dialog.detail.handleCellClick}
        handleAddRow={dialog.detail.handleAddRow}
        handleDeleteRow={dialog.detail.handleDeleteRow}
        handleCopyRow={dialog.detail.handleCopyRow}
        handlePasteRow={dialog.detail.handlePasteRow}
        handleMoveRow={dialog.detail.handleMoveRow}
        handleCellValueChange={dialog.detail.handleCellValueChange}
        onRepeatForRows={dialog.detail.repeatRows}
        formMode={dialog.formMode}
        dienGiai={dialog.formState.state.dienGiai}
        handleUpdateNonWritableFields={dialog.detail.setNonWritableFields}
        handleUpdatePasteConfigs={dialog.detail.setPasteConfigs}
        constraints={dialog.constraints}
        isPasting={dialog.detail.isPasting}
      />
    )
  },
  {
    id: 'other',
    label: 'Khác',
    component: <OtherTab formMode={dialog.formMode} formState={dialog.formState} />
  },
  {
    id: 'e-invoice',
    label: 'HĐĐT(Không sử dụng)',
    component: <EInvoiceTab formMode={dialog.formMode} />
  }
];
